import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";

export const reducers = combineReducers({LoginReducer})